import { useUpdateTenant } from '@hakimo-ui/hakimo/data-access';
import { AdminTenantDetails } from '@hakimo-ui/hakimo/types';
import { Page } from '@hakimo-ui/hakimo/ui-layout';
import { Button } from '@hakimo-ui/shared/ui-base';
import { toast } from '@hakimo-ui/hakimo/util';
import { useMemo, useState } from 'react';
import { CreateTenantCard } from '../tenants-list/CreateTenantCard';

interface Props {
  tenant: AdminTenantDetails;
  onCancel: () => void;
  onSuccess: () => void;
}

export function EditTenant(props: Props) {
  const { tenant, onCancel, onSuccess } = props;
  const [editedSourceSystem, setEditedSourceSystem] = useState<
    'Motion' | 'Vision'
  >(tenant.productType === 'Scan' ? 'Vision' : 'Motion');

  const onUpdateSuccess = () => {
    toast('Tenant updated successfully', { type: 'success' });
    toast(
      'If appliance is configured, please contact engineering to update tenant configuration',
      { type: 'info' }
    );
    onSuccess();
  };

  const onUpdateError = (error: Error) => {
    toast(error.message || 'Failed to update tenant', { type: 'error' });
  };

  const updateMutation = useUpdateTenant(
    tenant.id,
    onUpdateSuccess,
    onUpdateError
  );

  const handleClickSave = () => {
    updateMutation.mutate({
      sourceSystem: editedSourceSystem,
    });
  };

  const isSaveDisabled = updateMutation.isLoading;

  const pageActions = useMemo(
    () => [
      <Button
        key="save"
        variant="primary"
        onClick={handleClickSave}
        disabled={isSaveDisabled}
        loading={updateMutation.isLoading}
      >
        Save
      </Button>,
      <Button
        key="cancel"
        onClick={onCancel}
        disabled={updateMutation.isLoading}
      >
        Cancel
      </Button>,
    ],
    [handleClickSave, isSaveDisabled, updateMutation.isLoading, onCancel]
  );

  return (
    <Page
      title="Edit"
      subtitle="Tenant"
      onClickBack={onCancel}
      pageActions={pageActions}
    >
      <div className="bg-hakimo-light-bg dark:bg-hakimo-dark-bg h-full px-4 py-8">
        <div className="mx-auto w-full max-w-6xl">
          <CreateTenantCard
            mode="edit"
            tenantId={tenant.id}
            tenantName={tenant.name}
            sourceSystem={editedSourceSystem}
            supportUserEmail={tenant.supportUserEmail}
            onSourceSystemChange={setEditedSourceSystem}
          />
        </div>
      </div>
    </Page>
  );
}

export default EditTenant;
